import { createSlice } from "@reduxjs/toolkit";
import { sliceNames } from "../helpers/constants";

const globalSliceReducerInitialState = {
    error: null,
    redirectPath: "/dashboard",
    permissions:[],
    userRole:null,
    userTimezone: null,
    timezoneLoading: false
};

const globalSlice = createSlice({
    name: sliceNames.GLOBAL,
    initialState: globalSliceReducerInitialState,
    reducers: {
        setGlobalError(state, action) {
            state.error = action.payload;
        },
        clearGlobalError(state) {
            state.error = null;
        },
        setRedirectPath: (state, action) => {
            state.redirectPath = action.payload;
        },
        clearRedirectPath: (state) => {
            state.redirectPath = "/dashboard";
        },

        // NEW: Set permissions after login
        setPermissions: (state, action) => {
            state.permissions = action.payload;
        },
        
        // NEW: Set user role
        setUserRole: (state, action) => {
            state.userRole = action.payload;
        },

        // NEW: Clear permissions on logout
        clearPermissions: (state) => {
            state.permissions = [];
            state.userRole = null;
        },
        
        // NEW: Set user timezone
        setUserTimezone: (state, action) => {
            state.userTimezone = action.payload;
        },
        
        // NEW: Set timezone loading state
        setTimezoneLoading: (state, action) => {
            state.timezoneLoading = action.payload;
        },
        
        // NEW: Clear timezone on logout
        clearUserTimezone: (state) => {
            state.userTimezone = null;
            state.timezoneLoading = false;
        },
    },
});

export const {
    setGlobalError,
    clearGlobalError,
    setRedirectPath,
    clearRedirectPath,
    setPermissions,
    setUserRole,
    clearPermissions,
    setUserTimezone,
    setTimezoneLoading,
    clearUserTimezone,
} = globalSlice.actions;

export default globalSlice.reducer;